import { useMemo } from "react";
import { DEMAND, REQUEST_TYPES } from "@demandproai/shared";
//eslint-disable-next-line no-unused-vars
import useCompanyTier from "./useCompanyTier";

// Returns the list of demand types that should be excluded from download/version menus for a given case
export const useExcludedDemands = (caseData) => {
    // For July release this is not payment gated
    // const { isSilverTier } = useCompanyTier();
    const isSilverTier = false;

    const isCostProjectionReady = (caseData?.createRequests?.[REQUEST_TYPES.MEDICAL_SUMMARY]?.isCostProjectionReady || caseData?.createRequests?.[REQUEST_TYPES.DEMAND]?.isCostProjectionReady) ?? false;

    return useMemo(() => {
        const excluded = [DEMAND.Medical_Chronology];
        if (!caseData?.s3LifecarePlanZipUrlPath) {
            excluded.push(DEMAND.Certified_Lifecare_Plan);
        }
        if (isSilverTier || !isCostProjectionReady) {
            excluded.push(DEMAND.Lifecare_Plan);
        }
        return excluded;
    }, [caseData?.s3LifecarePlanZipUrlPath, isSilverTier, isCostProjectionReady]);
};
